module.exports = __webpack_public_path__ + "img/growth-dark.172392d2.svg";